/**
 * Import required libraries
 */
import React from "react";
import { useTheme, makeStyles } from "@material-ui/core";

const styles = makeStyles(theme => ({
  root: {
    cursor: "pointer",
    height: 17,
    "&:hover": {
      filter: "brightness(1.2)"
    }
  }
}));

/**
 * SvgClose Component
 */
const SvgClose = props => {
  const theme = useTheme();
  // CSS classnames
  const classes = styles();
  return (
    <div {...props}>
      <svg
        className={classes.root}
        viewBox="0 0 24 24"
        width="100%"
        height="100%"
      >
        <path
          d="M16.9 15.5L13.4 12l3.5-3.5-1.4-1.4-3.5 3.5-3.5-3.5-1.4 1.4 3.5 3.5-3.5 3.5 1.4 1.4 3.5-3.5 3.5 3.5zM12 2c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12 6.5 2 12 2z"
          fill={theme.palette.error.main}
        />
        <path
          d="M7.632 16.311l-.723-.72 1.823-1.815 1.823-1.815-1.823-1.816L6.91 8.329l.723-.72.722-.719 1.823 1.816L12 10.52l1.823-1.815 1.823-1.816.722.72.723.72-1.823 1.815-1.823 1.816 1.823 1.815 1.823 1.816-.723.72-.722.719-1.823-1.815L12 13.4l-1.823 1.816-1.823 1.815z"
          fill="#fff"
        />
      </svg>
    </div>
  );
};

export default SvgClose;
